import utils from "../utils";

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

const getLocalStorage = () => utils.hasValue(localStorage) ? localStorage : null;

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

const localParams =
{
    get: (key, defValue = null) =>
    {
        try
        {
            const storage = getLocalStorage();
            if(storage)
            {
                const value = storage.getItem(key);
                return utils.hasValue(value) ? value : defValue;
            }
        }
        catch(e)
        {
            console.debug(`localParams.get(${key}, ${defValue}): ${e}`);
        }

        return defValue;
    },

    set: (key, value) =>
    {
        try
        {
            const storage = getLocalStorage();
            if(storage)
            {
                storage.setItem(key, value);
                return true;
            }
        }
        catch(e)
        {
            console.debug(`localParams.set(${key}, ${value}): ${e}`);
        }

        return false;
    },

    getBool(key, defValue = null)     // function required for this object
    {
        return utils.boolCast(this.get(key, defValue));
    },

    setBool(key, value)
    {
        return this.set(key, value.toString());
    },

    remove: key =>
    {
        try
        {
            const storage = getLocalStorage();
            if(storage)
            {
                storage.removeItem(key);
                return true;
            }
        }
        catch(e)
        {
            console.debug(`localParams.remove(${key}): ${e}`);
        }

        return false;
    },

    clear: () =>
    {
        try
        {
            const storage = getLocalStorage();
            if(storage)
            {
                storage.clear();
                return true;
            }
        }
        catch(e)
        {
            console.debug(`localParams.clear(): ${e}`);
        }

        return false;
    }
};

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export default localParams;

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
